module.exports = __webpack_public_path__ + "static/media/light-ltr.2009f429.png";